import { createAction } from '@reduxjs/toolkit';
import * as actionTypes from './actionTypes';

export const setPrint = createAction<{
  field: FlattenKeys<PrintState>;
  value: any;
}>(actionTypes.SET_PRINT);

export const resetPrint = createAction<void>(actionTypes.RESET_PRINT);

const printActions = (dispatch: <T>(action: any) => T) =>
  Object.assign(
    {},
    {
      setPrint: <T extends FlattenKeys<PrintState>>(
        field: T,
        value: DeepType<PrintState, T>,
      ) => dispatch<void>(setPrint({ field, value })),
      resetPrint: () => dispatch<void>(resetPrint()),
    },
  );

export default printActions;
